module.exports = __webpack_public_path__ + "media/application/images/unesco-743c55c280fd3de290650cee898040c475294cc16e045d96a7063228d446a785.png";